import { Button, Divider, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomDrawer from '../../components/CustomDrawer';
import { formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/commons';

const useStyles = makeStyles((theme) => ({
    content: {
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            margin: 0,
        },
    },
    boxItemContent: {
        padding: theme.spacing(3, 4, 3, 4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
    },
    box: {
        padding: theme.spacing(2, 2, 0, 0)
    },
    box_first: {
        paddingTop: theme.spacing(2)
    },
    box_second: {
        paddingTop: theme.spacing(1)
    },
    print_button: {
        marginTop: theme.spacing(8),
        color: theme.palette.common.white,
        border: '1px solid ' + theme.palette.common.white,
    },
}));

export default function InvoiceDetailView(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { item, currency } = props;

    return (
        <>
            <CustomDrawer
                open={props.open}
                onClose={props.onClose}
                title={t('account_management')}
                classContent={classes.content}
            >
                <Grid item xs={12}>
                    <Grid item xs={12} container className={classes.boxItemContent}>
                        <Grid xs={12} item container direction='row'>
                            <Grid item xs={6}>
                                <Typography variant='body2'>
                                    {item.posted_date ? formatDateToDDMMYYYYHHSSFrEpoch(item.posted_date) : ""}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='subtitle2'>
                                    {currency}{item.total ? item.total.toFixed(2) : "0.00"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_net_amount')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{currency}{item.net ? item.net.toFixed(2) : "0.00"}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_tax_amount')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{currency}{item.tax ? item.tax.toFixed(2) : "0.00"}</Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ width: '100%', marginTop: 20, marginBottom: 20 }} />
                        <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_number')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{item.number}</Typography>
                            </Grid>
                        </Grid>
                        {item.issued_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_issued_date')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.issued_date)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.posted_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_posted_date')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.posted_date)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.invoice && item.invoice.due_date && <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_due_date')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{formatDateToDDMMYYYYFrEpoch(item.invoice.due_date)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.invoice && item.invoice.overdue_amount > 0 && <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('invoice_overdue_amount')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{item.invoice.overdue_amount ? item.invoice.overdue_amount.toFixed(2) : "0.00"}</Typography>
                            </Grid>
                        </Grid>}
                        {item.payment_method && <Grid item xs={12} container direction='row' className={classes.box_second}>
                            <Grid item xs={6}>
                                <Typography variant='body1'>{t('payment_method')}</Typography>
                            </Grid>
                            <Grid item xs={6} container justify='flex-end'>
                                <Typography variant='body1'>{item.payment_method.type}{"-"}</Typography>
                                <Typography variant='body1'>{item.payment_method.identity && item.payment_method.identity.identifier ? item.payment_method.identity.identifier : null}</Typography>
                            </Grid>
                        </Grid>}
                    </Grid>
                    {item.invoice && <Grid item xs={12}>
                        <Button variant='outlined' onClick={() => props.onPrint(item.entity_id)} className={classes.print_button}>{t('print_out')}</Button>
                    </Grid>}
                </Grid>
            </CustomDrawer>
        </>
    )
}